export const column_select_menu = {
  columns: "Columns",
} as const;
